// This is local file
/**
 * Constant for pointing http://api.dev-n-test.com/messages
 */
//MESSAGES_API_BASE_URL : 'https://api-dev.myschoollink.app/messages', // Base url for development server
/**
 * Constant for pointing http://api.dev-n-test.com/users
 */

//USERS_API_BASE_URL : 'https://api-dev.myschoollink.app/users' // Base url for development server
// USERS_API_BASE_URL : 'http://localhost:5000/users' // Base url for development server

let MESSAGES_API_BASE_URL = '';
let USERS_API_BASE_URL = '';
let EPUBLISHER_API = '';

if (window.location.hostname === "admin.myschoollink.app") {
     MESSAGES_API_BASE_URL = 'https://api.myschoollink.app/api/v1/messages';
     USERS_API_BASE_URL = 'https://api.myschoollink.app/api/v1/users';
     EPUBLISHER_API = 'https://sl-epub-link.myschoollink.app';
}else if (window.location.hostname === "admin-dev.myschoollink.app") {
     MESSAGES_API_BASE_URL = 'https://api-dev.myschoollink.app/api/v1/messages';
     USERS_API_BASE_URL = 'https://api-dev.myschoollink.app/api/v1/users';
     EPUBLISHER_API = 'https://sl-epub-link-dev.myschoollink.app';
} else if (navigator.userAgent.includes('Intel Mac OS 1')) {
     USERS_API_BASE_URL = 'http://localhost:5001/users';
     MESSAGES_API_BASE_URL = 'https://api.myschoollink.app/messages';
     EPUBLISHER_API = 'https://sl-epub-link-dev.myschoollink.app';
}else {
     MESSAGES_API_BASE_URL = 'http://localhost:5010/api/v1/messages';
     USERS_API_BASE_URL = 'http://localhost:5010/api/v1/users';
     EPUBLISHER_API = 'https://sl-epub-link-dev.myschoollink.app';
     //EPUBLISHER_API = 'http://localhost:3006';
}

// Super Admin User ID
const SUPER_ADMIN_ID = 39;

export { MESSAGES_API_BASE_URL, USERS_API_BASE_URL, EPUBLISHER_API, SUPER_ADMIN_ID };

